export default __webpack_public_path__ + "static/media/pocket.88a7185d.png";